"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchPDP } from "@/lib/centra/fetchersSetup";

export const useProductSizes = (productUri?: string) => {
  return useQuery({
    queryKey: ["product-sizes", productUri],
    queryFn: async () => {
      if (!productUri) return null;

      const product = await fetchPDP(productUri);
      return product?.data?.sizes || [];
    },
    enabled: !!productUri,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
